import { render, staticRenderFns } from "./TheSnapshotAssignmentGrades.vue?vue&type=template&id=8dd33ab4&scoped=true&"
import script from "./TheSnapshotAssignmentGrades.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotAssignmentGrades.vue?vue&type=script&lang=js&"
import style0 from "./TheSnapshotAssignmentGrades.vue?vue&type=style&index=0&id=8dd33ab4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd33ab4",
  null
  
)

export default component.exports